// extracted by css-extract-rspack-plugin
export default {"pageLinkList":"_3c854739","pageLinkItem":"_8b7e4d2e","arrowWrapper":"_60a182","arrowWrapperPrev":"_4b49bf3","arrowWrapperNext":"_a722e185","alignLeft":"_752a61e"};